<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
    >
      <div class="d-inline-flex">
        <h1 class="h2">Usinas</h1>

        <hr class="vertical-bar" />
      </div>

      <b-form-input
        autofocus
        v-on:keyup.enter="search"
        v-model="viewData.search"
        placeholder="Digite um termo e pressione enter para buscar"
        class="mr-3"
      ></b-form-input>

      <BaseButtonComponent
        class="mr-3"
        to="/power-plant/new"
        variant="primary-action"
        >Nova</BaseButtonComponent
      >

      <vue-json-to-csv :json-data="state.listCSV" :separator="';'">
        <BaseButtonComponent block variant="primary-action">
          CSV
        </BaseButtonComponent>
      </vue-json-to-csv>
    </div>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
    >
      <v-table>
        <thead>
          <tr>
            <td>Nome</td>
            <td>CPF/CNPJ</td>
            <td>Responsável Principal</td>
            <td>Razão Social do Gerador</td>
            <td>Número da Instalação</td>
            <td>Tarifa-base para remuneração</td>
            <td>Tarifa da Usina</td>
            <td>Porcentagem</td>
            <td>Cooperativa</td>
            <td>Região</td>
            <td>Estado</td>
            <td>Cidade</td>
            <td>Proprietário do Imóvel</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.name }}</td>
            <td>{{ formatSocialNumber(item.socialNumber) }}</td>
            <td>{{ item.main_owner }}</td>
            <td>{{ item.power_plant_alias }}</td>
            <td>{{ item.power_plant_installation_number }}</td>
            <td>{{ item.base_tariff }}</td>
            <td>{{ item.powerTariff || 0 }}</td>
            <td>{{ item.percentage }}</td>
            <td>
              <a :href="`/#/cooperative/edit/${item.cooperativeId}`">{{
                item.cooperativeName
              }}</a>
            </td>
            <td>
              <span v-if="item.region === 'CentroOeste'">Centro Oeste</span>
              <span v-else>{{ item.region }}</span>
              <span></span>
            </td>
            <td>{{ item.state }}</td>
            <td>{{ item.city }}</td>
            <td>{{ item.lessor_property }}</td>

            <td style="text-align: right">
              <BaseButtonComponent
                :to="`/power-plant/edit/${item.id}`"
                size="sm"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </v-table>

      <b-pagination-nav
        class="mt-3"
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import VueJsonToCsv from 'vue-json-to-csv';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'power-plant-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
        listCSV: [],
      },
      viewData: {
        loading: true,
        search: '',
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }

    await this.getAll();
  },
  methods: {
    formatSocialNumber(socialNumber) {
      if (socialNumber.length === 11) {
        return socialNumber.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/g,
          '$1.$2.$3-$4',
        );
      } else {
        return socialNumber.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
          '$1.$2.$3/$4-$5',
        );
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/power-plants' + helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;

        this.state.listCSV = this.state.list.map(item => ({
          Nome: item.name,
          CNPJ: this.formatSocialNumber(item.socialNumber),
          Responsavel_Principal: item.main_owner || '',
          Razao_Social_do_Gerador: item.power_plant_alias || '',
          Numero_da_Instalacao: item.power_plant_installation_number || '',
          Tarifa_base_para_remuneracao: item.base_tariff || '',
          Tarifa_Usina: item.powerTariff || '',
          Porcentagem: item.percentage || '',
          Cooperativa: item.cooperativeName || '',
          Regiao: item.region,
          Estado: item.state || '',
          Cidade: item.city || '',
          Proprietário_do_Imovel: item.lessor_property || '',
        }));
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${item.name}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        await API.post('/execute', {
          path: '/power-plant/' + item.id,
          method: 'delete',
        });

        this.$toast.success('Usina excluída com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    VueJsonToCsv,
    BaseButtonComponent,
  },
};
</script>

<style lang="scss" scoped>
.fixed-columns {
  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
  }

  td:nth-child(2),
  th:nth-child(2) {
    position: sticky;
    left: 4rem;
  }
}
</style>
